<script lang="ts">
    import { LOGO_WIDTH_M, LOGO_WIDTH_L } from '$lib/components/constants';

    import { cn } from '$lib/utils/cn';

    import type { LogoSize } from '$lib/types/Components/Logos/LogosContent';

    export let images: string[] = [];
    export let isGrayscale = false;
    export let size: LogoSize = 'medium';

    const derivedLogoWidth = size === 'medium' ? LOGO_WIDTH_M : LOGO_WIDTH_L;
</script>

{#each images as image, index (`${image}-${index}`)}
    <div
        class={cn('fun-flex fun-items-center fun-justify-center fun-px-6', {
            'fun-h-6': size === 'medium',
            'fun-h-9': size === 'large',
        })}
        style:width={`${derivedLogoWidth}px`}
    >
        <div class="fun-relative fun-size-full">
            <img
                src={image}
                alt={`Logo #${index}`}
                class={cn('fun-mx-auto fun-h-full fun-object-contain', {
                    'fun-grayscale': isGrayscale,
                })}
                aria-hidden="true"
            />
        </div>
    </div>
{/each}
